export default function VerticalDotsIcon() {
  return (
    <>
      <path
        d='M13.969 10C15.0564 10 15.938 9.10457 15.938 8C15.938 6.89543 15.0564 6 13.969 6C12.8815 6 12 6.89543 12 8C12 9.10457 12.8815 10 13.969 10Z'
        fill='#A0383F'
      />
      <path
        d='M13.9689 9.5C14.7845 9.5 15.4457 8.82843 15.4457 8C15.4457 7.17157 14.7845 6.5 13.9689 6.5C13.1533 6.5 12.4922 7.17157 12.4922 8C12.4922 8.82843 13.1533 9.5 13.9689 9.5Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
      <path
        d='M13.969 16C15.0564 16 15.938 15.1046 15.938 14C15.938 12.8954 15.0564 12 13.969 12C12.8815 12 12 12.8954 12 14C12 15.1046 12.8815 16 13.969 16Z'
        fill='#A0383F'
      />
      <path
        d='M13.9689 15.5C14.7845 15.5 15.4457 14.8284 15.4457 14C15.4457 13.1716 14.7845 12.5 13.9689 12.5C13.1533 12.5 12.4922 13.1716 12.4922 14C12.4922 14.8284 13.1533 15.5 13.9689 15.5Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
      <path
        d='M13.969 22C15.0564 22 15.938 21.1046 15.938 20C15.938 18.8954 15.0564 18 13.969 18C12.8815 18 12 18.8954 12 20C12 21.1046 12.8815 22 13.969 22Z'
        fill='#A0383F'
      />
      <path
        d='M13.9689 21.5C14.7845 21.5 15.4457 20.8284 15.4457 20C15.4457 19.1716 14.7845 18.5 13.9689 18.5C13.1533 18.5 12.4922 19.1716 12.4922 20C12.4922 20.8284 13.1533 21.5 13.9689 21.5Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
    </>
  );
}
